import type IPayDevice from '../interfaces/pay-device';

import iPP350 from '../devices/iPP350';

import { ConfigObservable } from 'bz-stores/lib/config';

class DeviceManager {
  public static Create(): IPayDevice {
    const { config } = ConfigObservable;
    const device = {
      type: config['TM3_PAYMENTS_DEVICE'] || '',
      port: config['TM3_PAYMENTS_DEVICE_PORT'] || '9000'
    };

    const port = parseInt(device.port);

    switch (device.type) {
      case 'iPP350':
        return new iPP350(port);
      default:
        throw 'Unknown device type';
    }
  }
}

export default DeviceManager;
